import { ANCHOR_TYPES } from 'src/app/components/Elements/Anchor';
import { CardWithInnerTitle } from 'src/app/components/Elements/Card/CardWithInnerTitle';
import { IconAndText } from 'src/app/components/Elements/IconAndText';
import { SectionWithTitle } from 'src/app/components/Elements/SectionWithTitle';
import { getAddressMapUrl } from 'src/app/utils';
import { CAPSULE_ICON_STRINGS } from 'src/consts';

interface PrescriberSectionProps {
  name: string;
  phoneNumber: string;
  firstAddressRowText: string;
  secondAddressRowText: string;
}

export const PrescriberSection = ({
  name,
  phoneNumber,
  firstAddressRowText,
  secondAddressRowText,
}: PrescriberSectionProps) => {
  const hasAddressText = firstAddressRowText || secondAddressRowText;
  const prescriberHasNoPhoneAndNoAddress = !phoneNumber && !hasAddressText;
  return (
    <SectionWithTitle sectionTitle="Prescriber">
      <CardWithInnerTitle cardTitle={name} cardTitleMarginBottom={prescriberHasNoPhoneAndNoAddress ? undefined : 's5'}>
        {phoneNumber && (
          <IconAndText
            anchorOptions={{ type: ANCHOR_TYPES.callTelephone, href: phoneNumber }}
            textList={[phoneNumber]}
            iconString={CAPSULE_ICON_STRINGS.phone}
          />
        )}
        {hasAddressText && (
          <IconAndText
            anchorOptions={{
              type: ANCHOR_TYPES.openInNewTab,
              href: getAddressMapUrl(firstAddressRowText, secondAddressRowText),
            }}
            textList={[firstAddressRowText, secondAddressRowText]}
            iconString={CAPSULE_ICON_STRINGS.checkout_address}
          />
        )}
      </CardWithInnerTitle>
    </SectionWithTitle>
  );
};
